export default __webpack_public_path__ + "static/media/nft-ultra.f41d301a.jpg";